const Paused = ({ title, ...props }) => (
  <svg viewBox="0 0 24 24" {...props}>
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        d="M12 3a9 9 0 109 9 9.011 9.011 0 00-9-9z"
        fill="#FE9526"
        fillRule="nonzero"
      />
      <rect fill="#FFF" x={9} y={8} width={2} height={8} rx={1} />
      <rect fill="#FFF" x={13} y={8} width={2} height={8} rx={1} />
    </g>
  </svg>
);

export default Paused;
